import { useModal } from '@ebay/nice-modal-react'
import { useSearch } from '@tanstack/router'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AnnouncementCarousel,
  MessageModal,
  PasswordResetModal,
  WebTitle,
} from '../components/common'
import { RedeemBonus } from '../components/home'
import {
  Banner,
  Categories,
  MoreMore,
  PlatformCards,
  SecuritySection,
} from '../components/home-v2'
import { Layout } from '../components/layouts'
import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import type { Game } from '../types/game'
import type { ResetCredentials } from '../types/user'
import { api } from '../utils/api-client'

const Home = () => {
  const username = useBoundStore(state => state.user.username)
  const messageModal = useModal(MessageModal)
  const passwordResetModal = useModal(PasswordResetModal)
  const { t } = useTranslation('common')
  const { reset_password } = useSearch({ from: '/' })
  const [slots, setSlots] = useState<Game[]>([])

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    const getAllGames = async () => {
      for (let i = 0; i < 3; i++) {
        try {
          const response = await api.get<Game[]>(
            '/data/games_v2.php?category=15647&limit=20',
            undefined,
            { signal },
          )
          const games = response.data
          if (games) {
            setSlots(games)
            break
          }
        } catch (err) {
          setSlots([])
          if (!axios.isCancel(err)) {
            console.error(err)
          }
        }
      }
    }
    getAllGames()

    return () => {
      controller.abort()
    }
  }, [])

  useEffect(() => {
    if (!reset_password) return
    if (username) {
      messageModal.show({
        title: '',
        message: t('already-logged-in'),
      })

      return
    }

    const controller = new AbortController()
    const signal = controller.signal

    const reqBody = { type: 'verify_reset_password', hash: reset_password }
    api.post('/request.php', reqBody, { signal }).then(res => {
      const { status, info } = res.data as ApiResponse<
        ResetCredentials | string
      >
      if (status === 1 && typeof info !== 'string') {
        passwordResetModal.show({
          code: info?.code ?? '',
          email: info?.email ?? '',
        })
      } else if (typeof info === 'string') {
        messageModal.show({
          title: t('system'),
          message: info,
        })
      }
    })

    return () => {
      controller.abort()
    }
  }, [reset_password])

  return (
    <Layout>
      <WebTitle page="home" />
      <AnnouncementCarousel containerStyle={{ marginTop: 10 }} />
      <Banner />
      <MoreMore />
      <PlatformCards />
      <Categories slots={slots} />
      <SecuritySection />
      <RedeemBonus />
    </Layout>
  )
}

export default Home
